module.exports = __webpack_public_path__ + "img/ch16_02_马三拦路求助.c54b268c.jpg";